<template>
  <div class="tab-pane active" id="photos-tab" role="tabpanel">
    <div class="mb-1">
      <span class="photoicon"><i class="fa fa-picture-o" aria-hidden="true"></i>
        <span>{{photos.length}}</span>
      </span> <span class="font1rem"> Tagesfotos vom
      <span>
        <span v-show="report.constructionreport.reporttype==='W'">
          {{ formatDate(report.constructionreport.reportstartdate) }} - </span>
        {{ formatDate(report.constructionreport.crdate) }}
      </span>
    </span>
      <!--      <div class="dropdown dd2 float-right mt-1">-->
<!--        <span class="font12">{{$t('sort_by')}}</span>-->
<!--        <a class="dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown"-->
<!--           aria-haspopup="true" aria-expanded="false">-->
<!--        </a>-->
<!--        <div class="dropdown-menu " aria-labelledby="navbarDropdown">-->
<!--          <a class="dropdown-item" @click="sortByDateAsc" href="#">Datum aufstg.</a>-->
<!--          <a class="dropdown-item" @click="sortByDateDesc" href="#">Datum abstg.</a>-->
<!--          <a class="dropdown-item" @click="sortByIdAsc" href="#">Nr. aufstg.</a>-->
<!--          <a class="dropdown-item" @click="sortByIdDesc" href="#">Nr. abstg.</a>-->
<!--          <a class="dropdown-item" @click="allowDrag" href="#">Individuell</a>-->
<!--        </div>-->
<!--      </div>-->
    </div>
    <div class="draggable row row-cols-3">
      <div class="col section-images simple-photo p-1 mt-2" v-for="(image , index) in photos" :key="index">
        <PhotoInfoPopup :photo="image" :isConstruction="true"/>
        <div  data-aspect-ratio="4:3" class="img-fluid position-relative">
          <input v-model="report_selected_photos" class="d-none" type="checkbox" :id="'construction_photo_'+image.runid" :value="image.pdphotoid">
          <label :for="'construction_photo_'+image.runid" :style="{'background-image': 'url(\'' + getImagePath(image.pdphotoid) + '\')'}"></label>
          <div class="simple-photo-option photo mw-100 rounded-bottom mb-0">
            <ul>
              <li>Nr.{{image.runid}}</li>
              <li>|</li>
              <li>{{image.photodate | setDate}}  </li>
              <li>|</li>
              <li>{{image.photodate | setTime}} Uhr</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import PhotoInfoPopup from './PhotoInfoPopup'
import {mapState} from 'vuex'
import {formatDate, formatTimeUhr} from "../../../common";
export default {
  props: ['report'],
  data () {
    return {
      is_draggable: false,
      report_selected_photos: [],
      report_images: [],
    }
  },
  components: { PhotoInfoPopup},
  computed: {
    ...mapState({
      photos : state => state.constructionDiary.photosFiles,
      selectedPhotos : state => state.constructionDiary.selected_report_photos
    }),
  },
  filters: {
    setDate: (date) => formatDate(date),
    setTime: (date) => formatTimeUhr(date)
  },
  methods: {
    formatDate: (date) => formatDate(date),
    getImagePath(photo_id) {
      const project_id = this.$route.params.id
      return `${process.env.VUE_APP_GET_METHOD_URL}img&projectid=${project_id}&id=${photo_id}&token=${localStorage.sessiontoken}&PHPSESSID=${localStorage.sessiontoken}`
    },
    unCheckImage (index) {
      this.$store.commit('unSelectImage', index)
    },
    sortByDateDesc () {
      this.photos.sort(function (a, b) {
        return new Date(b.crdate) - new Date(a.crdate)
      })
    },
    sortByDateAsc () {
      this.photos.sort(function (a, b) {
        return new Date(a.crdate) - new Date(b.crdate)
      })
    },
    sortByIdAsc () {
      this.photos.sort(function (a, b) {
        return (b.runid - a.runid)
      })
    },
    sortByIdDesc () {
      this.photos.sort(function (a, b) {
        return (a.runid - b.runid)
      })
    },
    allowDrag () {
      this.is_draggable = true
    }
  },
  watch: {
    'report_selected_photos' : function (photos_ids){
      const photos = [];
      photos_ids.forEach(id => {
        const photo = this.photos.find(ph => ph.pdphotoid == id)
        const selected_photo = this.selectedPhotos.find(p => p.pdphotoid == id)
        const selected_img = this.report_images.find(p => p.pdphotoid == id)
        if (selected_photo || selected_img){
          const img = selected_photo || selected_img;
          photos.push({...img,...photo})
        }else {
          photos.push({...photo ,descriptionextend: photo.description})
        }
      })
      this.$store.commit('setReportSelectedPhotos',photos)
    },
    photos: function (){
      const attached_photos = this.report.constructionreport.reportparams.attached_photos || null;
      if (attached_photos){
        this.report_selected_photos = attached_photos.map(photo => photo.pdphotoid);
        this.report_images = JSON.parse(JSON.stringify(attached_photos));
      }
    }
  }
}
</script>
<style>
.draggable .section-images:hover i{
  display: block !important;
  cursor: pointer !important;
  /*top: -7px;*/
  /*left: 3px;*/
  font-size: 16px;
  z-index: 999;
}
h5 a{
  padding-bottom: 5px;
}
#dtab5.tab-pane{
  min-width: 28rem;
}
#dtab5 .dropdown-menu{
  transform: none !important;
  left: -50px !important;
  top: 15px !important;
}
.simple-photo-option.photo{
  max-width: 95%;
}
div.section-images input:checked + label{
border: 5px solid #39F;
}
div.section-images label{
border-radius: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/constructionDiary/components/SideBar/ConstructionPhotosTab.vue